import React from "react";

/**
 * Specification of props required to inject a route into the router.
 */
export type RouteProps = {
    /**
     * Specifies the path that this route will match. When setting up paths, you
     * can add wildcards using ":[name]" (for instance "/user/:user_id").
     *
     * If you've added any wildcards, the matched values will be added to your
     * render function as params.
     */
    path?: string;

    /**
     * The callback that'll be triggered when the path specified is matched;
     * this is where you'll define what to actually render.
     *
     * If for some reason you can't find the content to render for the given
     * path (for instance if the given user_id doesn't exist). and you'd like to
     * fall back to the generic <RouteNotFound ... /> component, then you can
     * return null.
     *
     * If you return a promise, then the router will wait for your component to
     * be ready for rendering. This makes it easy to implement code splitting
     * and deferred content loading.
     */
    render?(path: string, params: { [key: string]: string }): Promise<React.JSX.Element | null> | React.JSX.Element | null;
};

/**
 * Use the <Route ... /> component to declaratively inject routes into your
 * application using jsx syntax.
 */
// tslint:disable-next-line variable-name
export const Route: React.FC<RouteProps> = () => null;
